import { BaseIcon, BaseIconProps } from './BaseIcon';

export const PenToolGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="penToolGrad" {...props}>
    <path 
      d="m12 19 7-7 3 3-7 7-3-3z" 
      stroke="url(#penToolGrad)" 
    />
    <path 
      d="m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5zM2 2l7.586 7.586" 
      stroke="url(#penToolGrad)" 
    />
    <circle cx="11" cy="11" r="2" stroke="url(#penToolGrad)" />
  </BaseIcon>
);
